import { useStytchStore } from '@/stores/stytchStore'
import { Routes } from '@/router/Routes'
import { unref } from 'vue'
import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'

export default (...roles: string[]) => {
    return (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
        const stytch = useStytchStore()
        const stytchAuth = unref((stytch as any).isAuthenticated) ?? (stytch as any).isAuthenticated
        const stytchRoles = unref((stytch as any).roles) ?? (stytch as any).roles ?? []
        if (stytchAuth && Array.isArray(stytchRoles) && roles.some((r) => stytchRoles.includes(r))) {
            return next()
        } else {
            next({
                name: Routes.Unauthorized,
            })
        }
    }
}
